<his-plam [label]="label">
    <his-multiselect
        #content
        [ngModel]="selectedOptionsModel()"
        (ngModelChange)="onSelectedOptionsChange($event)"
        [hisDdKey]="ddKey"
        [dataSource]="dataSource"
        [field]="field"
        [customOptionsMethod]="customOptionsMethod"
        [suggestions]="suggestions()"
        [label]="label"
        [limit]="limit"
        [showDropdownIcon]="showDropdownIcon"
        [showNullItem]="showNullItem"
        [minLength]="minLength"
        [showDeleteButton]="showDeleteButton()"
        [showSelectButton]="showSelectButton()"
        [editMode]="editMode()"
        [selectButtonImage]="selectButtonImage"
        [selectButtonTooltip]="selectButtonTooltip"
        [selectedOptions]="selectedOptions()"
        [removeSelectedOptionsFromDropdown]="removeSelectedOptionsFromDropdown()"
        [resultRowsPerPage]="resultRowsPerPage"
        [maxRows]="maxRows"
        [maxSelectedOptions]="maxSelectedOptions"
        [maxDisplayedSelections]="maxDisplayedSelections"
        (selectedOptionsChange)="selectedOptionsChange.emit($event)"
        [sortMethod]="sortMethod"
        (selected)="selected.emit($event)"
        [group]="group()" />
</his-plam>